// Casca das telas de autenticação: logo, cartão central e rodapé com links legais.
import type { ReactNode } from 'react'
import { Link } from 'react-router-dom'
import './auth.css'

/** Logo de verdade (o mesmo do site), centralizado, para as telas de entrada, link e erro. */
export function BrandLogo() {
  return (
    <Link to="/" className="logo auth-logo">
      <img src="/logo.png" alt="" className="logo-img" />
      Seu Impulso
    </Link>
  )
}

export default function AuthShell({ title, sub, children, footer, wide }: { title: string; sub?: ReactNode; children: ReactNode; footer?: ReactNode; wide?: boolean }) {
  return (
    <div className="auth-wrap" style={{ background: 'var(--bg)' }}>
      <div className="auth-card" style={wide ? { width: 'min(560px, 100%)' } : undefined}>
        <BrandLogo />
        <div className="card" style={{ padding: 24 }}>
          <h1 style={{ fontSize: 22 }}>{title}</h1>
          {sub && <p className="muted mt-8">{sub}</p>}
          <div className="mt-16">{children}</div>
        </div>
        {footer && <div className="small muted mt-16" style={{ textAlign: 'center' }}>{footer}</div>}
        <div className="small muted mt-16 row" style={{ justifyContent: 'center', gap: 24, flexWrap: 'wrap' }}>
          <Link to="/termos" className="auth-hit">Termos de uso</Link>
          <Link to="/privacidade" className="auth-hit">Privacidade</Link>
        </div>
      </div>
    </div>
  )
}

/** Mensagem de erro de formulário (acessível). */
export function FormError({ error }: { error: string | null | undefined }) {
  if (!error) return null
  return <div className="form-error" role="alert">{error}</div>
}

export function FormOk({ children }: { children: ReactNode }) {
  return <div className="form-ok" role="status">{children}</div>
}
